import { render, staticRenderFns } from "./Builder.vue?vue&type=template&id=805c1dd0&"
import script from "./Builder.vue?vue&type=script&lang=js&"
export * from "./Builder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports